import React from "react";
import AnimatedSection from './AnimatedSection';
import SectionHeading from './SectionHeading';

const blogs = [
  {
    category: "The Hidden Corners of Linux — 30 Days of Deep Kernel Magic",
    stories: 31,
    url: "https://medium.com/@ashwinsri04/list/the-hidden-corners-of-linux-30-days-of-deep-kernel-magic-94c58bddda1d"
  },
  {
    category: "The Networking Playbook - 30 Days from Basics to Pro",
    stories: 31,
    url: "https://medium.com/@ashwinsri04/list/the-networking-playbook30-days-from-basics-to-pro-511935e469ad" 
  },
  {
    category: "Distributed Systems: How Real Systems Fail & Survive",
    stories: 9,
    url: "https://medium.com/@ashwinsri04/list/distributed-systems-how-real-systems-fail-survive-b789c0ada400" 
  },
  {
    category: "MLOps Complete Guide - From Zero to Hero",
    stories: 6,
    url: "https://medium.com/@ashwinsri04/list/the-mlops-atlas-maps-for-modern-machine-learning-systems-4e04f5da1468" 
  },
  {
    category: "All about Finops - Cloud Financial Management",
    stories: 1,
    url: "https://blog.stackademic.com/all-about-finops-the-complete-guide-to-cloud-financial-management-5bee5dc5337d" 
  }
];

export default function Blogs() {
  return (
    <AnimatedSection id="blogs">
      <SectionHeading number={5}>My Blogs</SectionHeading>
      <div className="grid md:grid-cols-3 gap-8 items-start">
        {blogs.map((section) => (
          <div
            key={section.category}
            className="p-6 rounded-xl flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-1"
            style={{ background:'rgba(15,23,42,0.7)', border:'1px solid rgba(30,41,59,0.7)', backdropFilter:'blur(8px)', boxShadow:'0 4px 24px rgba(0,0,0,0.3)' }}
          >
            <h2 className="text-xl font-mono text-teal-200 mb-4">{section.category}</h2>
            <p className="text-slate-100 mb-6 text-lg">{section.stories} Stories</p>
            <a
              href={section.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal-300 font-bold py-2 px-6 rounded-lg transition-all duration-300 font-mono text-sm hover:shadow-[0_0_16px_rgba(45,212,191,0.3)]" style={{ background:'rgba(45,212,191,0.1)', border:'1px solid rgba(45,212,191,0.3)' }}
            >
              Read Series
            </a>
          </div>
        ))}
      </div>
    </AnimatedSection>
  );
}
